import Model from '../Model';
import Mithril from 'mithril';

export default class Pkg extends Model {
  pkgId() {
    return Model.attribute<number>('pkgId').call(this);
  }
  subGameId() {
    return Model.attribute<number>('subGameId').call(this);
  }
  gameKey() {
    return Model.attribute<string>('gameKey').call(this);
  }

  logoId() {
    return Model.attribute<string>('logoId').call(this);
  }
}
